import { ComponentType, ReactNode, Suspense } from "react";

export function withSuspense<WrappedProps extends object>(
  WrappedComponent: ComponentType<WrappedProps>,
  suspenseProps: { fallback: ReactNode },
): ComponentType<WrappedProps> {
  function WrapperComponent(props: WrappedProps) {
    return (
      <Suspense fallback={suspenseProps.fallback}>
        <WrappedComponent {...props} />
      </Suspense>
    );
  }

  return WrapperComponent;
}
